import { z } from "zod";
import { sessionStore } from "../../../lib/store";

/**
 * "Later" on the acquisition question hides it for this session only: it comes
 * back in the next one, until the question is answered. One store for the
 * desktop corner card and the phone's chat card. The composer band reads it
 * too, because the topic cards wait behind the question.
 */
export const acquisitionCardDismissedStore = sessionStore(
  "acquisition-card-dismissed",
  false,
  z.boolean()
);
